export type Primitive = boolean | number | string | bigint | symbol | null | undefined;

/**
 * Checks whether the value is primitive. (number, string, boolean, ...) and not an Object
 *
 * @param value - Value that is being checked.
 * @return - Boolean that says whether the value is primitive.
 */
export function isPrimitive (value: unknown): value is Primitive {
  return (value !== Object(value));
}
